// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2RV26","title":"Header_title__1fTp8","left":"Header_left__1E2TI","clinicName":"Header_clinicName__1aQYA"};